<template>
<v-card flat>
    <form>
        <div class="text-field--width" style="line-height: 3;">
            <label class="subheading font-weight-regular font-weight-regular">Monitor Name</label>
            <v-text-field
                    :error-messages="monitorNameErrors"
                    :loading="!create && !monitorFetchReady"
                    :readonly="authenticatedUser.is_user"
                    :value="monitorName"
                    @input="mname => monitorName = mname"
                    background-color="#e2e2e2"
                    class="custom-box"
                    color="bindezcolor"
                    height="41"
                    hint="The name display in your dashboard"
                    outline
                    placeholder="Monitor Name"
                    required
                    single-line
            >
            </v-text-field>
        </div>
<!--        <div class="text-field&#45;&#45;width" style="line-height: 3;">-->
<!--            <label class="subheading font-weight-regular font-weight-regular">Monitor Type</label>-->
<!--            <v-radio-group :disabled="!create" v-model="type" row>-->
<!--                <v-radio color="bindezcolor" :ripple="false" label="Buzz Monitor" value="keyword"></v-radio>-->
<!--                <v-radio color="bindezcolor"  :ripple="false" label="Page Monitor" value="page"></v-radio>-->
<!--            </v-radio-group>-->
<!--        </div>-->
        <div class="text-field--width" style="line-height: 3;">
            <label class="subheading font-weight-regular font-weight-regular">Industry</label>
            <v-autocomplete
                    :error-messages="monitorIndustryErrors"
                    :items="hIndustries"
                    :loading="!fetchIndustryReady || (!create && !monitorFetchReady)"
                    :readonly="authenticatedUser.is_user"
                    :ripple="false"
                    background-color="#e2e2e2"
                    class="custom-box"
                    color="bindezcolor"
                    height="41"
                    item-text="name"
                    item-value="uuid"
                    label="Select Industry"
                    outline
                    required
                    single-line
                    v-model="monitorIndustry"
            >
            </v-autocomplete>
        </div>
        <div style="line-height: 3;">
            <label class="subheading font-weight-regular">Description</label>
            <v-textarea
                    :error-messages="monitorDescriptionErrors"
                    :loading="!create && !monitorFetchReady"
                    :readonly="authenticatedUser.is_user"
                    :value="monitorDescription"
                    @input="mdescription => monitorDescription = mdescription"
                    auto-grow
                    background-color="#e2e2e2"
                    class="custom-box"
                    color="bindezcolor"
                    outline
                    placeholder="Monitor Description"
                    required
                    rows="5"
                    single-line
            >
            </v-textarea>
            <div class="text-xs-right">
                <!-- for create purpose update button must be next -->
                <v-btn
                        :loading="processing"
                        :dark="!generalSectionInvalid"
                        :disabled="generalSectionInvalid || (!monitorFetchReady && !create)"
                        @click="monitorAction"
                        color="bindezcolor"
                        depressed
                        small
                >
                    <span class="text-capitalize font-weight-regular" style="font-size: 14px;">{{ create ? 'Next' : 'Update Monitor'}}</span>
                </v-btn>
            </div>
        </div>
    </form>
</v-card>

</template>

<script>
	import {required} from 'vuelidate/lib/validators'
	import {mapMutations, mapState, mapGetters, mapActions} from 'vuex'
    import authCurrentUser from "../../mixins/authCurrentUser";
    import _unescape from 'lodash/unescape';

    import _debounce from 'lodash/debounce';


	export default {
		name: "GeneralSection",
        props:['create','processing'],
        mixins:[authCurrentUser],
		validations: {
			monitorName: {
				required
			},
			monitorIndustry: {
				required
			},
			monitorDescription: {
				required
			},
		},

		computed: {
			...mapState('monitors', [
				'name',
				'description',
				'industry_uuid',
				'monitorFetchReady',
                'generalSectionInvalid',
                'fetchIndustryReady',
                "monitorType"
			]),

			...mapGetters('monitors', [
				'hIndustries'
			]),

            /*
                v-model modifier doesn't work in vuetify input fields.
                For this reason, monitorName and monitorDescription
                use _debounce to prevent vuex state from updating every key stroke.
            */
			monitorName: {
				get() {
					return _unescape(this.name);
				},
				set: _debounce(function (name) {
					this.$v.$touch();
					this.setMonitorName(name);
				}, 200)
			},

			monitorIndustry: {
				get() {
					return this.industry_uuid;
				},
				set(industry) {
					this.setMonitorIndustry(industry);
				}
			},

			monitorDescription: {
				get() {
					return this.description;
				},
				set: _debounce(function (description) {
					this.$v.$touch();
					this.setMonitorDescription(description);
				}, 200)
			},

            // type:{
			// 	get(){
            //         return this.monitorType;
            //     },
            //     set(type){
            //         this.setMonitorType(type);
            //     }
            // },

			monitorNameErrors() {
				const errors = [];
				if (!this.$v.monitorName.$dirty) return errors;
				!this.$v.monitorName.required && errors.push("Monitor Name is required");
				return errors;
			},

			monitorIndustryErrors() {
				const errors = [];
				if (!this.$v.monitorIndustry.$dirty) return errors;
				!this.$v.monitorIndustry.required && errors.push("Industry must be selected");
				return errors;
			},

			monitorDescriptionErrors() {
				const errors = [];
				if (!this.$v.monitorDescription.$dirty) return errors;
				!this.$v.monitorDescription.required && errors.push("Description is required");
				return errors;
			},

		},

		methods: {
			...mapActions('monitors', [
				'fetchIndustries'
			]),

			...mapMutations('monitors', [
				'setMonitorName',
				'setMonitorIndustry',
				'setMonitorDescription',
                'setFetchIndustryReady',
                'setGeneralSectionValidation',
                'setMonitorType',
			]),

			monitorAction() {
				this.$ua.trackEvent("Monitor", "click", `${this.authenticatedUser.email || 'User' } add general info to monitor`);
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.setGeneralSectionValidation(this.$v.$invalid);
					if (this.create) {
						this.$emit('next')
					} else {
						this.$emit('next', 'update')
					}
				}

			},
		},

		watch: {
			'$v.$invalid': {
				handler(isValid) {
					this.setGeneralSectionValidation(isValid);
				},
				immediate: true
			}
		},

		created() {
            this.setFetchIndustryReady(false);
            this.fetchIndustries()
                .then(_ => this.setFetchIndustryReady(true))
		},

	}
</script>

<style scoped>
    .text-field--width {
        width: 600px;
    }

	.industry-filter {
		border: 1px solid #cecece;
	}

	.v-btn.v-btn--small, .v-btn.v-btn--large {
        height: 41px;
    }
</style>
